import { Combobox } from '@/components/common/Combobox'
import type { FieldInputProps } from '../types'

export function SelectInput({ field, value, onChange, disabled }: FieldInputProps) {
  return (
    <Combobox<string>
      value={typeof value === 'string' && value !== '' ? value : null}
      onChange={v => onChange(v)}
      options={field.options.map(o => ({ value: o.value, label: o.labelPl }))}
      emptyOptionLabel="—"
      placeholder="Wybierz..."
      disabled={disabled}
    />
  )
}
